<template>
  <h3>跟随做多 理解做空 顺势而为</h3>
  <h4>如果市场交易赛力斯机器人，记住核心，拉面！</h4>
  <h5>放低心理预期、</h5>
  <div class="daily-container">
  <el-button @click="handleAdd" type="primary" class="mb-4"  v-if="isAdmin" >新增文章</el-button>

    <el-table
      :data="dailies"
      border
      style="width: 100%"
      @row-click="handleShowDetail"
      class="custom-table"
    >
      <el-table-column prop="title" label="标题" align="left" min-width="500" />
      <el-table-column prop="create_time" label="更新时间" align="center" width="180" />
      <el-table-column
        label="操作"
        align="center"
        width="220"
        class-name="operation-cell"
      >
        <template #default="scope">
          <el-button
            @click.stop="handleEdit(scope.row)"
            type="primary"
            size="small"
            class="action-btn"
             v-if="isAdmin"
          >
            编辑
          </el-button>
          <el-button
            @click.stop="handleDelete(scope.row.id)"
            type="danger"
            size="small"
            class="action-btn"
             v-if="isAdmin"
          >
            删除
          </el-button>
          <el-button
            @click.stop="handleShowDetail(scope.row)"
            type="primary"
            size="small"
            class="action-btn"
          >
            详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

 <el-pagination
    class="mt-4"
    layout="prev, pager, next"
    :total="total"
    :page-size="pageSize"
    v-model:current-page="currentPage"
    @current-change="handlePageChange"
  />

    <!-- 抽屉组件 -->
    <el-drawer
      v-model="drawerVisible"
      :title="selectedDaily.title || '详情'"
      direction="rtl"
      size="30%"
      :before-close="handleDrawerClose"
    >
      <div class="drawer-content">
         <div class="mb-2">
          <span class="value">  {{ selectedDaily.content }}</span>
        </div>

        <!-- 显示图片 -->
        <div v-if="selectedDaily.images && selectedDaily.images.length > 0" class="mb-2">
          <div
            v-for="(image, index) in selectedDaily.images"
            :key="index"
            class="image-container"
          >
            <el-image
              :src="image.url"
              :preview-src-list="selectedDaily.images.map(img => img.url)"
              :initial-index="index"
              fit="cover"
              class="detail-image"
              lazy
            />
          </div>
        </div>

      <div class="mb-2">
  <span v-if="selectedDaily.is_stock == 1 && selectedDaily.contentLinks?.length > 0">
    <span v-for="(item, index) in selectedDaily.contentLinks" :key="index" class="value">
      <a :href="item.link" target="_blank">{{ item.code }}</a>
      <span v-if="index < selectedDaily.contentLinks.length - 1">、</span>
    </span>
  </span>
  <span v-else>
    暂无
  </span>
</div>


        <div class="mb-2">
          <span class="value">{{ selectedDaily.create_time }}</span>
        </div>
      </div>
    </el-drawer>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      v-model="dialogVisible"
      :title="isEdit ? '编辑文章' : '新增文章'"
      width="40%"
    >
      <el-form :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="form.title" autocomplete="off" />
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="form.content" type="textarea" :rows="20" />
        </el-form-item>
        <el-form-item label="相关股票">
            <el-input v-model="form.stocks" type="textarea" :rows="10" />
        </el-form-item>

        <!-- 图片上传 -->
        <el-form-item label="图片">
          <el-upload
            class="upload-demo"
            action="/api/upload"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
            :on-remove="handleUploadRemove"
            :on-preview="handleUploadPreview"
            multiple
            list-type="picture"
            :limit="5"
            :on-exceed="() => {$message.warning('最多只能上传5张图片')}"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <template #tip>
              <div class="el-upload__tip">
                jpg/png 文件大小不超过 2MB，最多可上传5张图片
              </div>
            </template>
          </el-upload>
        </el-form-item>


       <el-form-item label="是否置顶">
          <el-switch v-model="form.topic" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="是否股票">
          <el-switch v-model="form.is_stock" :active-value="1" :inactive-value="0" />
        </el-form-item>

      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">{{ isEdit ? '保存' : '提交' }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import axios from 'axios'

export default {
  data() {
    return {
      dailies: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      dialogVisible: false,
      form: { title: '', content: '', stocks: '', topic: 0, is_stock: 0, images: [] },
      isEdit: false,
      editId: 0,
      drawerVisible: false,
      selectedDaily: {},
      userRole: localStorage.getItem('username') || '',
      fileList: [] // 添加文件列表
    }
  },
  computed: {
      isAdmin() {
        return this.userRole === 'admin1984';
      }
    },
  watch: {
      userRole(newValue) {
        localStorage.setItem('username', newValue);
      }
  },
  methods: {
   handlePageChange(page) {
      this.currentPage = page; // 确保页码同步
      this.fetchData();        // 触发数据请求
    },
    async fetchData() {
      try {
        const res = await axios.get('/api/dailies', {
          params: {
            page: this.currentPage,
            pageSize: this.pageSize
          }
        })
        this.dailies = res.data.list
        this.total = res.data.total
      } catch (error) {
        ElMessage.error('获取数据失败')
        console.error('Fetch data error:', error)
      }
    },
    handleAdd() {
      this.form = { title: '', content: '', stocks: '', topic: 0, is_stock: 0, images: [] }
      this.isEdit = false
      this.editId = 0
      this.fileList = [] // 清空文件列表
      this.dialogVisible = true
    },
    handleEdit(daily) {
      this.form = { ...daily }
      // 初始化图片列表用于显示
      if (daily.images && Array.isArray(daily.images)) {
        this.fileList = daily.images.map(img => ({
          name: img.name || img.url.split('/').pop(),
          url: img.url,
          status: 'success'
        }))
        // 确保 form.images 是正确的格式
        this.form.images = [...daily.images]
      } else {
        this.fileList = []
        this.form.images = []
      }
      this.isEdit = true
      this.editId = daily.id
      this.dialogVisible = true
    },
    async handleDelete(id) {
      try {
        await axios.delete(`/api/dailies/${id}`)
        ElMessage.success('删除成功')
        await this.fetchData()
      } catch (error) {
        ElMessage.error('删除失败')
        console.error('Delete error:', error)
      }
    },
    async handleSubmit() {
      const payload = { ...this.form }
      delete payload.create_time // 不更新 create_time
      if (payload.update_time === null) {
        delete payload.update_time // ✅ 如果 update_time 为 null，则删除该字段
      }

      try {
        if (this.isEdit) {
          await axios.put(`/api/dailies/${this.editId}`, payload)
          ElMessage.success('更新成功')
        } else {
          await axios.post('/api/dailies', payload)
          ElMessage.success('新增成功')
        }
        this.dialogVisible = false
        await this.fetchData()
      } catch (error) {
        ElMessage.error('操作失败')
        console.error('Submit error:', error.response?.data || error)
      }
    },

    handleShowDetail(row) {
      this.selectedDaily = { ...row }

      // 判断 stocks 是否有值
      if (row.stocks && typeof row.stocks === 'string') {
        this.selectedDaily.contentLinks = row.stocks
          .split('、')
          .filter(code => !code.trim().endsWith(':'))
          .map(code => ({
            code: code,
            link: `https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${code}`
          }))
      } else {
        this.selectedDaily.contentLinks = []
      }

      this.drawerVisible = true
    },

    handleDrawerClose() {
      this.drawerVisible = false
    },

    // 在 DailyPage.vue 的 methods 中修改以下方法：

// 图片上传成功处理
handleUploadSuccess(response, file, fileList) {
  // 后端直接返回文件信息数组，我们需要处理单个文件的响应
  if (response && response.length > 0) {
    // 如果返回的是数组，取第一个文件
    const uploadedFile = response[0];
    this.form.images.push({
      name: uploadedFile.name,
      url: uploadedFile.url
    });
  } else if (response && response.url) {
    // 如果返回的是单个文件对象
    this.form.images.push({
      name: response.name || file.name,
      url: response.url
    });
  }
  this.fileList = fileList;
},

// 图片移除处理
handleUploadRemove(file, fileList) {
  // 从 form.images 中移除对应的图片
  const index = this.form.images.findIndex(img =>
    img.url === file.response?.url ||
    img.url === (file.response && file.response[0] ? file.response[0].url : null)
  );
  if (index > -1) {
    this.form.images.splice(index, 1);
  }
  this.fileList = fileList;
},

    // 图片预览处理
    handleUploadPreview(file) {
      window.open(file.url)
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>
.daily-container {
  padding: 20px;
}

.custom-table {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
}

/* 表头样式 */
.el-table th {
  background-color: #f5f7fa;
  color: #333;
  font-weight: 500;
  padding: 12px 16px;
}

/* 表格行悬停效果 */
.el-table__row:hover {
  background-color: #f5f7fa;
  cursor: pointer;
}

/* 单元格内边距 */
.el-table td {
  padding: 12px 16px;
}

/* 操作列样式 */
.operation-cell {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.action-btn {
  padding: 6px 12px !important;
  font-size: 12px !important;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .el-table__header th {
    padding: 8px 10px;
  }
  .el-table__row td {
    padding: 8px 10px;
  }
  .el-table-column--selection {
    width: 50px;
  }
}

/* 抽屉样式 */
.drawer-content {
  padding: 24px;
  line-height: 1.8;
}

.drawer-content .mb-2 {
  margin-bottom: 16px;
}

.label {
  font-weight: 500;
  color: #606266;
}

.value {
  color: #303133;
  word-break: break-all;
}

/* 对话框样式 */
.el-dialog__body {
  padding: 20px 40px 0;
}

.el-form {
  max-width: 600px;
}

/* 图片显示样式 */
.image-container {
  margin-bottom: 10px;
}

.detail-image {
  width: 100%;
  max-height: 300px;
  border-radius: 4px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.upload-demo {
  margin-bottom: 10px;
}

.el-upload__tip {
  font-size: 12px;
  color: #606266;
}
</style>
